import { EPostSeoBanStatus } from '.';

export enum EArticleUnavailableReason {
  NOT_FOUND = 'not_found',
  PRIVATE_ACCOUNT = 'private_account',
  UNDER_AGE_ACCOUNT = 'under_age',
  ERR_VISIBILITY = 'err_visibility_level',
  ERR_PERMISSION = 'err_permission',
  SEO_BAN_UNKNOWN = 'seo_ban_unknown',
  SERVER_ERROR = 'server_error',
}

export const SEOPostBanReasonMap: Record<EPostSeoBanStatus, EArticleUnavailableReason> = {
  [EPostSeoBanStatus.Unknown]: EArticleUnavailableReason.SEO_BAN_UNKNOWN,
  [EPostSeoBanStatus.PrivateAuthor]: EArticleUnavailableReason.PRIVATE_ACCOUNT,
  [EPostSeoBanStatus.AuthorUnderAge]: EArticleUnavailableReason.UNDER_AGE_ACCOUNT,
  [EPostSeoBanStatus.ErrVisibility]: EArticleUnavailableReason.ERR_VISIBILITY,
  [EPostSeoBanStatus.ErrPermission]: EArticleUnavailableReason.ERR_PERMISSION,
};

export interface IArticleUnavailableDetail {
  groupId: string;
  unavailableReason: EArticleUnavailableReason;
}
